// used at build time, so no TypeScript
import defaultConfig from "./default";

export default {
  ...defaultConfig,

  USER_URL: "https://beta-secure.ipdanalytics.com/User",
  // RUNTIME_GQL_URL: "http://localhost:3003/graphql",
  // CACHE_URL: "http://localhost:5000/cache",
  // PDF_URL: "http://localhost:5000/pdfReport",
};
